import React, { useState, useEffect } from 'react';
import {
  Button,
  FormControl,
  FormLabel,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Select,
  Checkbox,
  SimpleGrid,
  VStack,
} from '@chakra-ui/react';
import { getUserData } from 'utils';
import { createAPIEndPoint } from 'config/api/api';
import toast from 'react-hot-toast';

const AssignLocationModal = ({ isOpen, onClose, isLocationId = "", fetchAgain = () => { } }) => {
  const userData = getUserData();
  const clinic_id = userData?.clinic_id ?? null;
  console.log(" AssignLocationModal ~ isLocationId:", isLocationId)
  const [teamMembers, setTeamMembers] = useState([]);
  console.log('AssignLocationModal ~ teamMembers:', teamMembers);
  const [locations, setLocations] = useState([]);
  const [selectedMember, setSelectedMember] = useState('');
  console.log(" AssignLocationModal ~ selectedMember:", selectedMember)
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      fetchTeamMembers();
      if (!isLocationId) {
        fetchLocations();
      }
    }
  }, [isOpen]);



  const fetchTeamMembers = async () => {
    try {
      const response = await createAPIEndPoint(`clinic_team/get_all/${clinic_id}`).fetchAll();
      const members = response.data.team_members || [];
      // Map team members with full name
      const formattedMembers = members.map((member) => ({
        // id: member.id,
        id: member.user_id,
        name: `${member.first_name} ${member.last_name}`, // Combine first and last name
      }));

      setTeamMembers(formattedMembers);
    } catch (err) {
      toast(err?.response?.data?.error || 'Failed to fetch team members');
    }
  };

  const fetchLocations = async () => {
    try {
      const response = await createAPIEndPoint(`clinic_locations/get_all/${clinic_id}`).fetchAll();
      const locations = response.data.locations || [];

      // Map locations to format name, city, and state
      const formattedLocations = locations.map((location) => ({
        id: location.id,
        name: `${location.location_name} (${location.city}, ${location.state})`, // Display name with city & state
      }));

      setLocations(formattedLocations);
    } catch (err) {
      toast.error(err?.response?.data?.error || 'Failed to fetch locations');
    }
  };

  const assignLocations = async () => {
    setLoading(true);
    const payload = {
      clinic_id,
      staff_id: parseInt(selectedMember, 10),
      location_ids: !!isLocationId ? [isLocationId] : selectedLocations,
    };

    try {
      await createAPIEndPoint('clinic_team/assign-location').create(payload);
      toast.success('Locations assigned successfully!');

      if (isLocationId) {
        fetchAgain()
      }
      setSelectedMember('');
      setSelectedLocations([]);
      setTeamMembers([]);
      setLocations([]);
      onClose();
    } catch (err) {
      toast.error(err?.response?.data?.error || 'Failed to assign locations');
    } finally {
      setLoading(false);
    }
  };

  const handleLocationChange = (locationId) => {
    setSelectedLocations((prev) =>
      prev.includes(locationId)
        ? prev.filter((id) => id !== locationId)
        : [...prev, locationId],
    );
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent borderRadius="16px" pb="16px">
        <ModalHeader color="brand.500">
          Assign Locations to Team Members
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody maxHeight="70vh" overflowY="auto" pb={2}>
          <FormControl mb={4}>
            <FormLabel>Select Team Member</FormLabel>
            <Select
              variant="auth"
              fontSize="sm"
              fontWeight="500"
              placeholder="Select a team member"
              value={selectedMember}
              onChange={(e) => setSelectedMember(e.target.value)}
            >
              {teamMembers.map(({ id, name }) => (
                <option key={id} value={id}>
                  {name}
                </option>
              ))}
            </Select>
          </FormControl>

          {!isLocationId &&
            <FormControl>
              <FormLabel>Select Locations</FormLabel>
              <VStack align="start">
                <SimpleGrid columns={{ base: 1, md: 2 }} spacing={2}>
                  {locations.map((location) => (
                    <Checkbox
                      key={location.id}
                      isChecked={selectedLocations.includes(location.id)}
                      onChange={() => handleLocationChange(location.id)}
                    >
                      <span style={{ fontSize: '.85rem' }}>{location.name}</span>
                    </Checkbox>
                  ))}
                </SimpleGrid>
              </VStack>
            </FormControl>
          }
        </ModalBody>
        <ModalFooter>
          {/* <Button onClick={onClose} mr={2}>
            Cancel
          </Button> */}

          <Button
            w="100%"
            colorScheme="brand"
            onClick={assignLocations}
            isDisabled={!selectedMember || !isLocationId && selectedLocations.length === 0}
            isLoading={loading}
          >
            Assign
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default AssignLocationModal;


// import React, { useState, useEffect } from 'react';
// import {
//   Button,
//   FormControl,
//   FormLabel,
//   Modal,
//   ModalOverlay,
//   ModalContent,
//   ModalHeader,
//   ModalFooter,
//   ModalBody,
//   ModalCloseButton,
//   Checkbox,
//   SimpleGrid,
//   VStack,
//   InputGroup,
//   Input,
//   Menu,
//   MenuButton,
//   MenuList,
//   MenuItem,
//   Box,
//   Text
// } from '@chakra-ui/react';
// import { getUserData } from 'utils';
// import { createAPIEndPoint } from 'config/api/api';
// import toast from 'react-hot-toast';

// const AssignLocationModal = ({ isOpen, onClose, isLocationId = "", fetchAgain = () => { } }) => {
//   const userData = getUserData();
//   const clinic_id = userData?.clinic_id ?? null;

//   const [teamMembers, setTeamMembers] = useState([]);
//   const [locations, setLocations] = useState([]);

//   const [searchMember, setSearchMember] = useState('');
//   const [selectedMember, setSelectedMember] = useState('');

//   const [searchLocation, setSearchLocation] = useState('');
//   const [selectedLocations, setSelectedLocations] = useState([]);

//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     if (isOpen) {
//       fetchTeamMembers();
//       if (!isLocationId) fetchLocations();
//     }
//   }, [isOpen]);

//   const fetchTeamMembers = async () => {
//     try {
//       const response = await createAPIEndPoint(`clinic_team/get_all/${clinic_id}`).fetchAll();
//       const members = response.data.team_members || [];
//       const formatted = members.map(member => ({
//         id: member.user_id,
//         name: `${member.first_name} ${member.last_name}`,
//       }));
//       setTeamMembers(formatted);
//     } catch (err) {
//       toast(err?.response?.data?.error || 'Failed to fetch team members');
//     }
//   };

//   const fetchLocations = async () => {
//     try {
//       const response = await createAPIEndPoint(`clinic_locations/get_all/${clinic_id}`).fetchAll();
//       const formatted = (response.data.locations || []).map(location => ({
//         id: location.id,
//         name: `${location.location_name} (${location.city}, ${location.state})`,
//       }));
//       setLocations(formatted);
//     } catch (err) {
//       toast.error(err?.response?.data?.error || 'Failed to fetch locations');
//     }
//   };

//   const assignLocations = async () => {
//     setLoading(true);
//     const payload = {
//       clinic_id,
//       staff_id: parseInt(selectedMember, 10),
//       location_ids: !!isLocationId ? [isLocationId] : selectedLocations,
//     };

//     try {
//       await createAPIEndPoint('clinic_team/assign-location').create(payload);
//       toast.success('Locations assigned successfully!');
//       if (isLocationId) fetchAgain();
//       setSelectedMember('');
//       setSelectedLocations([]);
//       setTeamMembers([]);
//       setLocations([]);
//       onClose();
//     } catch (err) {
//       toast.error(err?.response?.data?.error || 'Failed to assign locations');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleLocationChange = (locationId) => {
//     setSelectedLocations(prev =>
//       prev.includes(locationId) ? prev.filter(id => id !== locationId) : [...prev, locationId]
//     );
//   };

//   const filteredMembers = teamMembers.filter(member =>
//     member.name.toLowerCase().includes(searchMember.toLowerCase())
//   );

//   const filteredLocations = locations.filter(location =>
//     location.name.toLowerCase().includes(searchLocation.toLowerCase())
//   );

//   return (
//     <Modal isOpen={isOpen} onClose={onClose} isCentered>
//       <ModalOverlay />
//       <ModalContent borderRadius="16px" pb="16px">
//         <ModalHeader color="brand.500">Assign Locations to Team Members</ModalHeader>
//         <ModalCloseButton />
//         <ModalBody maxHeight="70vh" overflowY="auto" pb={2}>
//           <FormControl mb={4}>
//             <FormLabel>Search Team Member</FormLabel>
//             <InputGroup>
//               <Input
//                 placeholder="Search team member..."
//                 value={searchMember}
//                 onChange={(e) => setSearchMember(e.target.value)}
//               />
//             </InputGroup>
//             <Menu>
//               <MenuButton as={Box} mt={2} border="1px solid #E2E8F0" borderRadius="md" p={2} cursor="pointer">
//                 <Text fontSize="sm">
//                   {selectedMember
//                     ? teamMembers.find(member => member.id === selectedMember)?.name
//                     : "Select a team member"}
//                 </Text>
//               </MenuButton>
//               <MenuList maxHeight="200px" overflowY="auto">
//                 {filteredMembers.map(member => (
//                   <MenuItem key={member.id} onClick={() => setSelectedMember(member.id)}>
//                     {member.name}
//                   </MenuItem>
//                 ))}
//               </MenuList>
//             </Menu>
//           </FormControl>

//           {!isLocationId && (
//             <FormControl>
//               <FormLabel>Search Locations</FormLabel>
//               <InputGroup mb={2}>
//                 <Input
//                   placeholder="Search location..."
//                   value={searchLocation}
//                   onChange={(e) => setSearchLocation(e.target.value)}
//                 />
//               </InputGroup>
//               <VStack align="start">
//                 <SimpleGrid columns={{ base: 1, md: 2 }} spacing={2}>
//                   {filteredLocations.map((location) => (
//                     <Checkbox
//                       key={location.id}
//                       isChecked={selectedLocations.includes(location.id)}
//                       onChange={() => handleLocationChange(location.id)}
//                     >
//                       <span style={{ fontSize: '.85rem' }}>{location.name}</span>
//                     </Checkbox>
//                   ))}
//                 </SimpleGrid>
//               </VStack>
//             </FormControl>
//           )}
//         </ModalBody>
//         <ModalFooter>
//           <Button
//             w="100%"
//             colorScheme="brand"
//             onClick={assignLocations}
//             isDisabled={!selectedMember || (!isLocationId && selectedLocations.length === 0)}
//             isLoading={loading}
//           >
//             Assign
//           </Button>
//         </ModalFooter>
//       </ModalContent>
//     </Modal>
//   );
// };

// export default AssignLocationModal;
